import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Button from '@Components/Button';


export default function ThesaurusExpandButton(props) {
  const {
    item,
    isOpen,
    isFolder,
    onToggleGroup,
  } = props;

  if (!isFolder) {
    return null;
  }

  return (
    <Button
      buttonConfig={{
        type: 'link',
        size: 'sm',
        e2eName: 'thesaurus-expand',
        ariaLabel: 'Expand',
      }}
      iconConfig={{
        name: `chevron-${isOpen ? 'down' : 'right'}`,
        size: 'tiny',
        className: 'tree-view-dialog-thesaurus-item-icon-expanded',
      }}
      onClick={() => {
        onToggleGroup(item);
      }}
    />
  );
}

ThesaurusExpandButton.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isFolder: PropTypes.bool.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
};
